import api from './api'

export const incidentalLoanService = {
  // Settings
  getSettings: () => {
    return api.get('/incidental-loans/settings')
  },

  createSettings: (data) => {
    return api.post('/incidental-loans/settings', data)
  },

  updateSettings: (id, data) => {
    return api.put(`/incidental-loans/settings/${id}`, data)
  },

  deleteSettings: (id) => {
    return api.delete(`/incidental-loans/settings/${id}`)
  },

  // Loan operations
  calculate: (data) => {
    return api.post('/incidental-loans/calculate', data)
  },

  getAll: (params = {}) => {
    return api.get('/incidental-loans', { params })
  },

  getById: (noPinjaman) => {
    return api.get(`/incidental-loans/${noPinjaman}`)
  },

  apply: (data) => {
    return api.post('/incidental-loans/apply', data)
  },

  approve: (noPinjaman) => {
    return api.post(`/incidental-loans/${noPinjaman}/approve`)
  },

  disburse: (noPinjaman, data) => {
    return api.post(`/incidental-loans/${noPinjaman}/disburse`, data)
  },

  pay: (noPinjaman, jumlahBayar, catatan = '') => {
    return api.post(`/incidental-loans/${noPinjaman}/pay`, {
      jumlahBayar,
      catatan
    })
  },

  topup: (noPinjaman, jumlahTopup, catatan = '') => {
    return api.post(`/incidental-loans/${noPinjaman}/topup`, {
      jumlahTopup,
      catatan
    })
  },

  reject: (noPinjaman, alasan) => {
    return api.post(`/incidental-loans/${noPinjaman}/reject`, { alasan })
  }
}
